var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"width":_vm.width,"modal-append-to-body":false,"append-to-body":false}},[_c('div',{staticClass:"headers"},[_vm._v("\n    "+_vm._s(_vm.dialogTitle)+"\n    "),(_vm.showClose)?_c('i',{staticClass:"el-icon-close cursorPointer",on:{"click":_vm.handelClose}}):_vm._e()]),_vm._t("dialog")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }